import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CatComposeRoutingModule } from './cat-compose-routing.module';
import { CatComposeParentComponent } from './cat-compose-parent/cat-compose-parent.component';
import { CatComposeFormComponent } from './cat-compose-form/cat-compose-form.component';
import { ClickOutsideDirective } from './click-outside.directive';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { CatEditModule } from '../cat-edit/cat-edit.module';

@NgModule({
  declarations: [
    CatComposeParentComponent,
    CatComposeFormComponent,
    ClickOutsideDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CatComposeRoutingModule,
    SharedComponentsModule,
    CatEditModule,
  ],
})
export class CatComposeModule {}
